import { render, staticRenderFns } from "./BuilderTextureCanvas.vue?vue&type=template&id=298bd284&"
import script from "./BuilderTextureCanvas.vue?vue&type=script&lang=js&"
export * from "./BuilderTextureCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports